export default __webpack_public_path__ + "static/media/logo-partner-1.8ae1d5de.png";